import React, { useContext, useState } from 'react';
import { RootContext } from '../../hoc/RootContext/RootContext';
import { Form } from 'react-bootstrap';
import { AdminModal, PageTitle } from '@project/components';
import AdminLogout from '../AdminLogout/AdminLogout';
import MenuToggle from './../Shared/MenuToggle/MenuToggle';
import { useIntl } from 'react-intl';

const Settings = ({ history }) => {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({id});

  const {
    currentUser: { fname, lname, email: currentEmail }
  } = useContext(RootContext);

  const [showName, setNameShow] = useState(false);
  const [showEmail, setEmailShow] = useState(false);
  const [name, setName] = useState(fname + ' ' + lname);
  const [email, setEmail] = useState(currentEmail);

  const handleNameClose = () => setNameShow(false);
  const handleEmailClose = () => setEmailShow(false);

  const handleSave = () => {
    setEmailShow(false);
    setNameShow(false);
  };

  return (
    <>
      <section>
        <PageTitle title={t('Settings.pageTitle')} />
        <header>
          <div className='d-flex'>
            <MenuToggle />
            <h3 className='is-page-title ml-3'>{t('Settings.title')}</h3>
          </div>
          <AdminLogout />
        </header>
        <main>
          <div className='d-flex flex-column'>
            <div className='d-flex flex-column mb-5'>
              <p className="font-md mb-3">{t('Settings.name')}</p>
              <label className="mb-3">{fname} {lname}</label>
              {/* <Link to='#' onClick={() => setNameShow(true)}>Change name</Link> */}
            </div>
            <div className='d-flex flex-column mb-5'>
              <p className="font-md mb-3">{t('Settings.email')}</p>
              <label className="mb-3">{email}</label>
              {/* <Link to='#' onClick={() => setEmailShow(true)}>Change email</Link> */}
            </div>
            <div className='d-flex flex-column'>
              <p className="font-md">{t('Settings.password')}</p>
              <label className="mb-3">************</label>
              {/* <Link to="/admin/settings">Change password</Link> */}
            </div>
          </div>
        </main>
      </section>
      <AdminModal title={t('Settings.changeName')} show={showName} onHide={handleNameClose} onSave={handleSave}>
        <Form className="is-common-form my-3">
          <Form.Group>
            <Form.Control id="name" type="text" onChange={(e) => setName(e.target.value)} name="name" value={name} />
          </Form.Group>
          {/* {errors ? <Alert key={errors} variant='danger'>Error: {errors}</Alert> : null} */}
        </Form>
      </AdminModal>
      <AdminModal title={t('Settings.changeEmail')} show={showEmail} onHide={handleEmailClose} onSave={handleSave}>
        <Form className="is-common-form my-3">
          <Form.Group>
            <Form.Control id="email" type="text" onChange={(e) => setEmail(e.target.value)} name="email" value={email} />
          </Form.Group>
          {/* {errors ? <Alert key={errors} variant='danger'>Error: {errors}</Alert> : null} */}
        </Form>
      </AdminModal>
    </>
  )
}

export default Settings;